export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7260.1143e21f.jpg";